import React from 'react';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';

import { SelfServiceType } from 'modules/selfServices/types/SelfService';
import { DEFAULT_MINUTES_TO_REOPEN_KIOSK } from 'modules/kiosk/constants';
import { SelfServiceSlotStatus, type Slot as SlotType } from 'modules/kiosk/types/Slot';

const ellipsis = 'text-center text-ellipsis overflow-hidden w-full whitespace-nowrap';

const Slot: React.FC<Omit<SlotType, 'rack'>> = ({
  id,
  position,
  referenceId,
  registration,
  selfServiceType,
  used,
  status,
  displayName,
}) => {
  const icon = selfServiceType === SelfServiceType.CHECK_IN ? 'fb-icon--hand-check-in' : 'fb-icon--hand-check-out';

  const isAssigned = status === SelfServiceSlotStatus.ASSIGNED;
  const isPreUnassigned = status === SelfServiceSlotStatus.PRE_UNASSIGNED;

  return (
    <li
      className={classNames(
        'relative flex flex-col justify-center w-72 min-h-32 items-center px-5 pt-7 pb-4 border-2 border-solid border-border-default rounded-admin-card',
        { 'bg-card-bg border-brand-high': used, 'bg-warning-default border-2 border-solid border-warning-default': isPreUnassigned },
      )}
      data-testid={`slot-${id}`}
    >
      <div
        className={classNames(
          'flex items-center justify-center absolute w-12 h-10 -top-5 border-solid border-2 bg-white border-border-default rounded-admin-card',
          { 'w-[82px] !bg-slot-number border-brand-high': used, '!bg-white border-2 border-solid border-warning-default': isPreUnassigned },
        )}
      >
        <span className="!text-xl font-bold">{position}</span>
        {used && <span className={classNames(icon, '!text-2xl ml-2 text-default')} />}
      </div>
      <span className={classNames(ellipsis, '!text-xl !leading-6 font-bold', { 'text-white': isPreUnassigned })}>
        {registration}
      </span>
      {isAssigned && (
        <>
          <span className={classNames(ellipsis, '!text-lg !leading-6')}>{referenceId}</span>
          {displayName && <span className={classNames(ellipsis, '!text-lg !leading-6')}>{displayName}</span>}
        </>
      )}
      {isPreUnassigned && (
        <span className="!text-lg !leading-6 text-center text-white">
          <FormattedMessage
            id="admin.slotReservation"
            defaultMessage="The slot is reserved up to {minutes} minutes"
            values={{ minutes: DEFAULT_MINUTES_TO_REOPEN_KIOSK }}
          />
        </span>
      )}
    </li>
  );
};

export default Slot;
